import Mutations from '../../odata/mutations';

export default { ...new Mutations('driedAbaloneSummary'), ...new Mutations('driedAbaloneSummaries') };
